import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { fetchCurrentUser } from "../../service/CurrentUser";
import CfLoader from "../../common/CfLoader/CfLoader";

const sidebarComponentToRouteMap = {
  Dashboard: "/issuer/discover",
  Designs: "/discovery",
  History: "/issuer/transaction/all",
  Draft: "/issuer/drafts",
  Approvals: "/issuer/approvals/all",
  Tenant: "/issuer/tenant",
};

const PostLoginRedirect = () => {
  const [targetPath, setTargetPath] = useState("/issuer/discover");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const determineRedirectPath = async () => {
      try {
        const userData = await fetchCurrentUser();

        if (userData?.sidebar_components?.length > 0) {
          const sidebarItem = userData.sidebar_components[0];
          let mappedPath =
            sidebarComponentToRouteMap[sidebarItem] || "/issuer/discover";

          if (
            sidebarItem === "Organisation" &&
            (userData.type === "Tenant_Admin" ||
              userData.type === "Tenant_User") &&
            userData.tenant_code &&
            userData.tenant_code.trim() !== ""
          ) {
            mappedPath = `/issuer/tenant/${userData.tenant_code}/organisations/users`;
          }

          setTargetPath(mappedPath);
        }
      } catch (error) {
        console.error("Error determining post-login redirect path:", error);
        setTargetPath("/issuer/discover");
      } finally {
        setIsLoading(false);
      }
    };

    determineRedirectPath();
  }, []);

  if (isLoading) {
    return (
      <div className="w-full min-h-screen bg-cfSecondary flex items-center justify-center">
        <CfLoader />
      </div>
    );
  }

  return <Navigate to={targetPath} replace />;
};

export default PostLoginRedirect;
